// components/process-units/InletSeparation.js
import React, { useState } from 'react';

const InletSeparation = ({ config, updateConfig }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  // Handle input changes
  const handleInputChange = (field, value) => {
    const numValue = parseFloat(value);
    if (!isNaN(numValue)) {
      updateConfig({
        [field]: numValue
      });
    }
  };

  return (
    <div className="process-unit-card">
      <div 
        className="unit-header" 
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <h3>Inlet Separation</h3>
        <span className={`expand-icon ${isExpanded ? 'expanded' : ''}`}>
          {isExpanded ? '▼' : '▶'}
        </span>
      </div>
      
      {isExpanded && (
        <div className="unit-content">
          <p className="unit-description">
            Inlet separation removes free liquids (water and hydrocarbons) from the gas stream 
            before further processing. This unit typically includes slug catchers, separation vessels, 
            and filtration equipment to protect downstream equipment.
          </p>
          
          <div className="parameter-group">
            <div className="parameter-row">
              <label>Operating Temperature (°C)</label>
              <input
                type="number"
                min="-50"
                max="100"
                step="1"
                value={config.temperature}
                onChange={(e) => handleInputChange('temperature', e.target.value)}
              />
            </div>
            
            <div className="parameter-row">
              <label>Pressure Drop (bar)</label>
              <input
                type="number"
                min="0"
                max="5"
                step="0.1"
                value={config.pressureDrop}
                onChange={(e) => handleInputChange('pressureDrop', e.target.value)}
              />
            </div>
            
            <div className="parameter-row">
              <label>Separator Type</label>
              <select 
                value={config.separatorType || 'threePhase'}
                onChange={(e) => updateConfig({ separatorType: e.target.value })}
              >
                <option value="twoPhase">Two-Phase (Gas-Liquid)</option>
                <option value="threePhase">Three-Phase (Gas-Hydrocarbon-Water)</option>
                <option value="slugCatcher">Slug Catcher</option>
              </select>
            </div>
            
            <div className="parameter-row">
              <label>Number of Separators</label>
              <input
                type="number"
                min="1"
                max="5"
                step="1"
                value={config.separatorCount || 1}
                onChange={(e) => handleInputChange('separatorCount', e.target.value)}
              />
            </div>
            
            <div className="parameter-row">
              <label>Heating Required</label>
              <select 
                value={config.heatingRequired ? 'yes' : 'no'}
                onChange={(e) => updateConfig({ heatingRequired: e.target.value === 'yes' })}
              >
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>
            
            {config.heatingRequired && (
              <div className="parameter-row">
                <label>Heating Duty (kW)</label>
                <input
                  type="number"
                  min="0"
                  step="10"
                  value={config.heatingDuty || 100}
                  onChange={(e) => handleInputChange('heatingDuty', e.target.value)}
                />
              </div>
            )}
          </div>
          
          <div className="unit-info-box">
            <h4>Engineering Notes</h4>
            <ul>
              <li>Three-phase separators are common in natural gas processing to separate gas, hydrocarbon liquids, and water.</li>
              <li>Slug catchers are used when intermittent slugs of liquid are expected from the upstream pipeline.</li>
              <li>Heating may be required to prevent hydrate formation or facilitate phase separation at low temperatures.</li>
              <li>Energy consumption in this unit is primarily from pumps, heaters (if used), and control systems.</li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default InletSeparation;